import { gql, useQuery } from "@apollo/client";
import useRetryOn429 from "hooks/useRetryOn429";
import { useEffect } from "react";
import { Select } from "../base/Form";

const FETCH_ODOO_STOCK_LOCATIONS = gql`
  query FETCH_ODOO_STOCK_LOCATIONS {
    odooStockLocations
  }
`;

const OdooStockLocationSelector = ({
  value,
  onSelect,
  initialValue,
  filterFunction,
  ...rest
}) => {
  const { loading, error, data, refetch } = useQuery(
    FETCH_ODOO_STOCK_LOCATIONS,
  );
  const { isAutoRetrying } = useRetryOn429({ error, refetch });

  useEffect(() => {
    if (data && initialValue && value !== initialValue) onSelect(initialValue);
  }, [data]);

  const odooStockLocations = data
    ? JSON.parse(data.odooStockLocations).filter((i) =>
        filterFunction ? filterFunction(i) : i,
      )
    : [];

  return (
    <Select
      value={value || "0"}
      onChange={(e) => onSelect(e.target.value)}
      {...rest}
    >
      {loading || isAutoRetrying ? (
        <option value="0" disabled>
          loading...
        </option>
      ) : error ? (
        <option value="0" disabled>
          {error.message}
        </option>
      ) : (
        <>
          <option value="0" disabled>
            --- Select ---
          </option>
          {odooStockLocations.map((i, index) => (
            <option key={index} value={i.id}>
              {i.display_name}
            </option>
          ))}
        </>
      )}
    </Select>
  );
};

export default OdooStockLocationSelector;
